import React, {Component} from 'react';
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import NumberFormat from "react-number-format";
import {Col, Row} from "reactstrap";
import ProgressInfoCard from "./ProgressInfoCard";
import {defterUnitName, showProgressPaymentFields} from "../../helper/permission";
import {EntegratorConf} from "../../constants";

class ProgressPaymentList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			parentCustomerId: this.props.parentCustomerId,
			totalCustomers: 0,
			activeCustomers: 0,
			totalSubDistributors: 0,
			totalCreditSell: 0,
			totalMbSell: 0,
			monthlyEarned: 0,
			totalEarned: 0,
			currentFactor: 0,
			loading: false
		};

		this.fetchData = this.fetchData.bind(this);
	}

	componentDidMount() {
		this.fetchData();
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.parentCustomerId !== this.props.parentCustomerId) {
			this.setState({parentCustomerId: nextProps.parentCustomerId}, () => this.fetchData());
		}
	}

	fetchData() {
		let self = this;
		let params = {
			url: `/progresspayment/getStats/` + this.state.parentCustomerId,
			method: "get"
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				let {
					totalCustomers,
					totalGIBCustomers,
					activeCustomers,
					totalSubDistributors,
					totalCreditSell,
					totalMbSell,
					monthlyEarned,
					totalEarned,
					currentFactor
				} = response.data;

				self.setState({
					totalCustomers,
					totalGIBCustomers,
					activeCustomers,
					totalSubDistributors,
					totalCreditSell,
					totalMbSell,
					monthlyEarned,
					totalEarned,
					currentFactor,
					loading: false
				});

			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	render() {

		return (
			<div className="card-body">
				<Row>
					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Başvuran Müşteri" body={this.state.totalCustomers}
										  mode="quickAccess" name="people" tooltipId='totalCustomer'/>
					</Col>

					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="GİB'e Bildirilmiş Müşteri" body={this.state.totalGIBCustomers}
										  mode="quickAccess" name="people" tooltipId='totalGIBCustomers'/>
					</Col>

					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Aktif Müşteri" body={this.state.activeCustomers}
										  mode="quickAccess" name="customer" tooltipId='activeCustomer'/>
					</Col>

					{showProgressPaymentFields(this.props.currentUser.customerId) &&
					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Hakediş Oranı" mode="quickAccess" name="percent"
										  body={<NumberFormat value={this.state.currentFactor ? this.state.currentFactor : 0}
															  displayType={'text'} thousandSeparator="." decimalSeparator=","
															  prefix={'%'}/>} tooltipId='percent'/>
					</Col>
					}

					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Toplam Bayi" body={this.state.totalSubDistributors}
										  mode="quickAccess" name="corporate" tooltipId='totalDistributor'/>
					</Col>

					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Toplam Kontör Satışı" mode="quickAccess"
										  name="check-circle-solid"
										  body={<NumberFormat value={this.state.totalCreditSell} displayType={'text'}
															  thousandSeparator="." decimalSeparator="," suffix={' Adet'}/>} tooltipId='totalCreditSales'/>
					</Col>

					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title={"Toplam "+defterUnitName(EntegratorConf.identifier)+" Satışı"} mode="quickAccess"
										  name="check-square-solid"
										  body={<NumberFormat value={this.state.totalMbSell} displayType={'text'} thousandSeparator="."
															  decimalSeparator="," suffix={' Mb'}/>} tooltipId='totalSpaceSales'/>
					</Col>

					{showProgressPaymentFields(this.props.currentUser.customerId) &&
					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Son Ayın Hakedişi" mode="quickAccess"
										  name="lira"
										  body={<NumberFormat value={this.state.monthlyEarned} displayType={'text'}
															  thousandSeparator="."
															  decimalSeparator="," suffix={' TL'}/>}
										  tooltipId='lastMonthProgress'/>
					</Col>
					}

					{showProgressPaymentFields(this.props.currentUser.customerId) &&
					<Col xs='12' sm='6' md='4' lg='4' xl='2'>
						<ProgressInfoCard loading={this.state.loading} title="Toplam Hakediş" mode="quickAccess"
										  name="lira"
										  body={<NumberFormat value={this.state.totalEarned} displayType={'text'}
															  thousandSeparator="."
															  decimalSeparator="," suffix={' TL'}/>}
										  tooltipId='totalProgress'/>
					</Col>
					}
				</Row>
			</div>
		);
	}
}

export default ProgressPaymentList;
